import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('conversations-thread-data', {
  library: 'conversations-thread-data'
});